import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["label", "button", "close"];

  connect() {
    if (this.isMobile() || this.isOnClientsPage()) {
      this.isExpanded = true;
      this.showLabel();
      this.expandSidebar(document.querySelector(".app-body .sidebar"));
      this.updateToggleButtonIcon();
    }

    if (!this.isMobile()) {
      $(this.buttonTarget).removeClass('d-none');
      this.closeTarget.style.display = "none";
    }

    this.permanentlyOpen = false;

    const sidebarToggleButton = this.element.querySelector(".sidebar-toggle-button");
    sidebarToggleButton.addEventListener("click", (event) => {
      this.toggleSidebar(event);
      this.hideTooltip(event);
    });

    if (this.isOnClientsPage()) {
      sidebarToggleButton.classList.add("opened");
    }
  }

  toggleLabel(event) {
    const sidebarElement = document.querySelector(".app-body .sidebar");

    if (event.type === "mouseenter" && this.permanentlyOpen == false) {
      this.isExpanded = true;
      this.showLabel();
      this.expandSidebar(sidebarElement);
      this.updateToggleButtonIcon();
    } else if (event.type === "mouseleave" && this.permanentlyOpen == false) {
      this.isExpanded = false;
      this.hideLabel();
      this.collapseSidebar(sidebarElement);
      this.updateToggleButtonIcon();
    }
    if (this.isMobile()) { this.showLabel() }
  }

  toggleSidebar(event) {
    const sidebarElement = document.querySelector(".app-body .sidebar");
    const isExpanded = sidebarElement.classList.contains("expanded");

    if (isExpanded) {
      this.hideLabel();
      this.collapseSidebar(sidebarElement);
      this.permanentlyOpen = false;
    } else {
      this.showLabel();
      this.expandSidebar(sidebarElement);
      this.permanentlyOpen = true;
    }

    this.isExpanded = !isExpanded;
    this.updateToggleButtonIcon();
  }

  isOnClientsPage() {
    const path = window.location.href.split("/").filter(Boolean);
    return path.includes("residents");
  }

  hideLabel() {
    this.labelTargets.forEach(label => {
      label.style.display = "none";
    });
  }

  showLabel() {
    this.labelTargets.forEach(label => {
      label.style.display = "inline";
    });
  }

  expandSidebar(sidebarElement) {
    if (this.isExpanded) {
      sidebarElement.classList.add("expanded");
    }
  }

  collapseSidebar(sidebarElement) {
    if (!this.isExpanded) {
      sidebarElement.classList.remove("expanded");
    }
  }

  isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  updateToggleButtonIcon() {
    const sidebarToggleButton = this.element.querySelector(".sidebar-toggle-button");
    sidebarToggleButton.innerHTML = `<i class="fa fa-chevron-${this.isExpanded ? 'left' : 'right'}"></i>`;
    sidebarToggleButton.setAttribute("data-original-title", (this.isExpanded ? 'Collapse': 'Expand'));
    if (this.isExpanded) {
      sidebarToggleButton.classList.add("opened")
    } else
    {
      sidebarToggleButton.classList.remove("opened")
    }
  }

  hideTooltip(event) {
    const sidebarToggleButton = event.currentTarget;
    $(sidebarToggleButton).tooltip('hide');
  }

  closeSidebar() {
    document.querySelector(".sidebar-mobile-show").classList.remove("sidebar-mobile-show")
  }
}
